import { EntryLinksDemand, Survey, SurveyMetadataForm } from '@ps/survey-utils';
import { Nullable } from '@ps/utils';

import { SurveyChildKey } from '../../survey-creation-shared-state.model';
import {
  SurveyChildRegistryState,
  SurveyCreationChildAudienceState,
} from '../../survey-creation-state.model';

// The audience form holds what the user last set for a survey; the saved
// survey only catches up after a refetch, so the form decides when it has a
// value and the saved survey covers a form that is not hydrated yet.
export function entryLinksDemandOf(
  metadata: Nullable<SurveyMetadataForm>,
  survey: Survey,
): EntryLinksDemand {
  return {
    completesRequired: metadata?.completes ?? survey.completesRequired,
    expectedIr: metadata?.incidence ?? survey.expectedIr,
  };
}

/** The demand of every participating survey, the active one included. */
export function participantEntryLinksDemand(
  coreChildren: Record<SurveyChildKey, SurveyChildRegistryState>,
  audienceChildren: Record<SurveyChildKey, SurveyCreationChildAudienceState>,
): EntryLinksDemand[] {
  return Object.entries(coreChildren).flatMap(
    ([key, { survey, participant }]) =>
      survey && participant !== false
        ? [entryLinksDemandOf(audienceChildren[key]?.metadata.value, survey)]
        : [],
  );
}
